{% block swag_migration_grid_selection %}
    <div class="swag-migration-grid-selection">
        {% block swag_migration_grid_selection_grid %}
            <sw-grid
                ref="tableDataGrid"
                :items="items"
                :selectable="false"
            >
                <template #columns="{ item }">
                    {% block swag_migration_grid_selection_grid_column_description %}
                        <sw-grid-column
                            flex="1fr"
                            :label="$tc('swag-migration.index.premappingCard.previousTitle')"
                        >
                            {{ item.description }}
                        </sw-grid-column>
                    {% endblock %}

                    {% block swag_migration_grid_selection_grid_column_choice %}
                        <sw-grid-column
                            class="swag-migration-grid-selection__choice-column"
                            flex="1fr"
                            :label="$tc('swag-migration.index.premappingCard.newAssignmentTitle')"
                        >
                            {% block swag_migration_grid_selection_grid_column_choice_field %}
                                <mt-select
                                    v-model="item.destinationUuid"
                                    class="swag-migration-grid-selection__choice-field"
                                    :class="getClassesAfterValidation(item)"
                                    :options="selectOptions"
                                    @update:model-value="onInput"
                                />
                            {% endblock %}
                        </sw-grid-column>
                    {% endblock %}
                </template>

                {% block swag_migration_grid_selection_grid_pagination %}
                    <template #pagination>
                        <sw-pagination
                            :page="page"
                            :limit="limit"
                            :total="total"
                            :total-visible="7"
                            :steps="paginationSteps"
                            @page-change="onPageChange" />
                    </template>
                {% endblock %}
            </sw-grid>
        {% endblock %}
    </div>
{% endblock %}
